import {Container, Grid, ThemeProvider} from '@material-ui/core';

import Profile from './components/Profile/Profile';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Portfolio from './pages/Portfolio/Portfolio';
import Resume from './pages/Resume/Resume';

import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import theme from './style';

import './App.css';
import Contact from './pages/ContactForm/Contact';
import Home from './pages/Home/Home';

import ParticalBackground from "../src/ParticalBackground"

function App () {

  return (
    <div className="app">
      {/* <ParticalBackground /> */}
      <ThemeProvider theme={theme}>
        <Container className="top_60">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={4} lg={3}>
              <Profile />
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={9}>
              <Router>
                <Header />
                <div className="main-content container_shadow ">
                  <Switch>
                    <Route exact path="/">
                      <Home />
                    </Route>
                    <Route exact path="/portfolio">
                      <Portfolio />
                    </Route>
                    <Route exact path="/resume">
                      <Resume />
                    </Route>
                    <Route exact path="/contact">
                      <Contact />
                    </Route>
                  </Switch>
                </div>
              </Router>
              <Footer />
            </Grid>
          </Grid>
        </Container>
      </ThemeProvider>

    </div>
  );
}

export default App;
